import type { SheetFormat } from '@porotutu/files/sheet'
import type { ExportScope } from '@porotutu/http/vocabulary'
import type { Locale } from '@porotutu/i18n'

type Query = Record<string, string | number | undefined>

export function exportHrefFor<Q extends Query>(
  path: string,
  keys: { always: readonly (keyof Q & string)[]; viewed: readonly (keyof Q & string)[] },
) {
  const copy = (search: URLSearchParams, query: Q, names: readonly (keyof Q & string)[]) => {
    for (const name of names) {
      const value = query[name]

      if (value !== undefined) search.set(name, String(value))
    }
  }

  return (query: Q, scope: ExportScope, format: SheetFormat, locale: Locale): string => {
    const search = new URLSearchParams({ format, scope, locale })

    copy(search, query, keys.always)
    copy(search, query, ['sort', 'direction'])

    if (scope === 'viewed') copy(search, query, keys.viewed)

    return `${path}?${search.toString()}`
  }
}
